import { logInfo } from '@/actions/metaActions';
import { userLogin } from '@/actions/authActions';
import { changeLoginWindow } from '@/actions/loginActions';
import { useDispatch } from '@/state/store';
import React, { useEffect, useRef, useState } from 'react';
import { ApiEnvironmentBadge } from './ApiEnvironmentBadge';
import Login from './auth/Login';
import { LoginButton } from './auth/LoginButton';
import Avgrensning from './avgrensning/Avgrensning';
import { SearchPanelOpenButton } from './avgrensning/search/SearchPanelOpenButton';
import Errors from './error/Errors';
import { InfoButton } from './info/InfoButton';
import LogoAndSplash from './info/LogoAndSplash';
import OLMapContainer from './map/OLMapContainer';
import { NotificationButton } from './notification/NotificationButton';
import { OpenPreferencesButton } from './preferences/OpenPreferencesButton';
import { Toolbar } from './Toolbar';
import { isMobileDevice } from '@/utils/Utils';
import { API_VERSION_STORAGE_KEY, LoginWindowState } from '@/state';
import { useSelector } from '@/state/store';
import { stateSplash, stateUser } from '@/selectors/selectors';
import { SplashState } from '@/state/SplashState';
import { listenForOAuthCallback } from '@/utils/pkce';
import { SVVTOKENS_KEY } from '@/utils/AuthenticationUtils';

export const Vegkart = () => {
    const hasLoggedVisit = useRef(false);
    const dispatch = useDispatch();
    const [usingV3, setUsingV3] = useState(
        sessionStorage.getItem(API_VERSION_STORAGE_KEY) == 'v3'
    );
    const splashState = useSelector(stateSplash);
    const userState = useSelector(stateUser);

    useEffect(() => {
        if (!hasLoggedVisit.current) {
            hasLoggedVisit.current = true;
            dispatch(logInfo('Opened Vegkart'));
        }
    }, [dispatch]);

    useEffect(() => {
        if (splashState === SplashState.NONE) {
            setUsingV3(sessionStorage.getItem(API_VERSION_STORAGE_KEY) == 'v3');
        }
    }, [splashState]);

    // Global OAuth callback listener (in case LoginForm is not mounted)
    useEffect(() => {
        const unsubscribe = listenForOAuthCallback(() => {
            const storedTokens = localStorage.getItem(SVVTOKENS_KEY);
            if (storedTokens) {
                const tokens = JSON.parse(storedTokens);
                dispatch(userLogin(tokens));
            }
        });
        return unsubscribe;
    }, [dispatch]);

    useEffect(() => {
        if (userState.isLoggedIn) {
            dispatch(changeLoginWindow(LoginWindowState.NONE));
        }
    }, [userState.isLoggedIn, dispatch]);

    useEffect(() => {
        // Handle before unload event
        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            if (document.visibilityState === 'visible' && isMobileDevice()) {
                event.preventDefault();
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        // Set class to determine navigation by mouse or keyboard, used for styling in body.less-file.
        const mouseListener = () => {
            document.body.classList.add('using-mouse');
        };
        const keyListener = () => {
            document.body.classList.remove('using-mouse');
        };
        document.body.addEventListener('mousedown', mouseListener);
        document.body.addEventListener('keydown', keyListener);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            document.body.removeEventListener('mousedown', mouseListener);
            document.body.removeEventListener('keydown', keyListener);
        };
    }, []);
    return (
        <div>
            <OLMapContainer />
            <LogoAndSplash />
            <Login />
            <Toolbar
                ariaLabel={'Diverse valg'}
                id={'app-controls'}
                orientation={'vertical'}
            >
                <NotificationButton />
                <InfoButton />
                <OpenPreferencesButton />
                <LoginButton />
            </Toolbar>
            <Avgrensning />
            <Errors />
            <SearchPanelOpenButton />
            <ApiEnvironmentBadge />
            {usingV3 && (
                <p className="c-preferences-api-warning">
                    NB! Les API-V3 er valgt. Denne versjonen vil snart avvikles. Vi
                    anbefaler å bytte til Les API-V4.
                </p>
            )}
        </div>
    );
};
